import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { router } from "src/routes";

const root = createRoot(document.getElementById("root")!);
root.render(<RouterProvider router={router} />);
